<!-- input输入框 -->
<template>
  <div class="form_input_wrap text_a_left bd_c_f margin_b_10">
    <div
      class="form_item_name"
      :class="option.isRequire ? 'form_item_isNeed' : ''"
      v-if="layout === 'vertical'"
    >
      {{ option.label }}
    </div>
    <div
      v-if="option.hasDescription && layout === 'vertical'"
      class="form_item_desc"
    >
      {{ option.description }}
    </div>
    <van-divider v-if="layout === 'vertical'" />

    <van-field
      :label="layout === 'horizontal' ? option.label : null "
      :class="layout === 'horizontal' ? (option.isRequire ? 'form_item_horizontal_isNeed' : '') : '' "
      type="number"
      v-model="option.value"
      @input="inputChange"
      :name="option.name"
      :error="error"
      :readonly="option.cannotEdit"
      :error-message="errorMessage"
      :placeholder="option.placeholder"
      :rules="[
        {
          validator: asyncValidator,
          message: $t('book.validator.require')
        }
      ]"
    />
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    layout: {
      type: String,
      default: "horizontal" // horizontal 水平 vertical 垂直
    }
  },
  data() {
    return {
      error: false,
      errorMessage: ''
    }
  },

  components: {},

  methods: {
    //格式校验方法
    asyncValidator(value) {
      return new Promise(resolve => {
        if (value.length > 0) {
          if (this.option.isVerify) {
            if (this.option.verifyType === 'phone') {
              resolve(this.CheckPhone(value))
            } else if (this.option.verifyType === 'email') {
              resolve(this.CheckEmail(value))
            } else if (this.option.verifyType === 'idNumber') {
              resolve(this.CheckIDNumber(value))
            } else if (this.option.verifyType === 'digit') {
              resolve(this.CheckDigit(value))
            } else if (this.option.verifyType === 'letter') {
              resolve(this.CheckLetter(value))
            }
          } else {
            resolve(this.SetCheckSuccMsg())
          }
        } else {
          if (this.option.isRequire) {
            resolve(this.SetCheckErrorMsg(this.$t('book.validator.require')))
          } else {
            resolve(this.SetCheckSuccMsg())
          }
        }
      })
    },
    // 设置校验不通过提示内容
    SetCheckErrorMsg(msg) {
      this.error = true
      this.errorMessage = msg
      return false
    },
    // 设置校验通过提示内容
    SetCheckSuccMsg() {
      this.error = false
      this.errorMessage = ''
      return true
    },
    // 校验手机号
    CheckPhone(value) {
      const phoneReg = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (phoneReg.test(value)) {
        this.SetCheckSuccMsg()
      } else {
        this.SetCheckErrorMsg(this.$t('book.validator.phone'))
      }
      return phoneReg.test(value)
    },
    // 校验邮箱
    CheckEmail(value) {
      const emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      if (emailReg.test(value)) {
        this.SetCheckSuccMsg()
      } else {
        this.SetCheckErrorMsg(this.$t('book.validator.email'))
      }
      return emailReg.test(value)
    },
    // 校验身份证号
    CheckIDNumber(value) {
      if (value.length >= 1) {
        if (this.checkCode(value)) {
          if (this.checkDate(value.substring(6, 14))) {
            if (this.checkProv(value.substring(0, 2))) {
              this.SetCheckSuccMsg()
              return true
            } else {
              this.SetCheckErrorMsg(this.$t('book.validator.idnumber'))
              return false
            }
          } else {
            this.SetCheckErrorMsg(this.$t('book.validator.idnumber'))
            return false
          }
        } else {
          this.SetCheckErrorMsg(this.$t('book.validator.idnumber'))
          return false
        }
      } else {
        this.SetCheckErrorMsg(this.$t('book.validator.idnumber'))
        return false
      }
    },
    // 校验数字
    CheckDigit(value) {
      // 整数或小数；小数时，小数点后最多保留两位
      // const digitReg = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^([^0][0-9]+|0)$/
      const digitReg = /^[1-9][0-9]*([.][0-9]{2})?$/
      if (digitReg.test(value)) {
        this.SetCheckSuccMsg()
      } else {
        this.SetCheckErrorMsg(
          this.$t('book.validator.digit')
        )
      }
      return digitReg.test(value)
    },
    // 校验字母
    CheckLetter(value) {
      const letterReg = /^[A-Za-z]+$/
      if (letterReg.test(value)) {
        this.SetCheckSuccMsg()
      } else {
        this.SetCheckErrorMsg(this.$t('book.validator.letter'))
      }
      return letterReg.test(value)
    },
    /**
     * @desc 校验身份证号省级地址
     * @param val 待校验的内容
     */
    checkProv(val) {
      let pattern = /^[1-9][0-9]/
      let provs = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门'
      }
      if (pattern.test(val)) {
        if (provs[val]) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    /**
     * @desc 校验出生日期
     * @param val 待校验的内容
     */
    checkDate(val) {
      let pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/
      if (pattern.test(val)) {
        let year = val.substring(0, 4)
        let month = val.substring(4, 6)
        let date = val.substring(6, 8)
        let tempDate = new Date(year + '-' + month + '-' + date)
        if (tempDate && tempDate.getMonth() == parseInt(month) - 1) {
          return true
        } else {
          return false
        }
      }
    },

    /**
     * @desc 校验码校验
     * @param val 待校验的内容
     */
    checkCode(val) {
      let pattern = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      let code = val.substring(17)
      if (pattern.test(val)) {
        let sum = 0
        for (let i = 0; i < 17; i++) {
          sum += val[i] * factor[i]
        }
        if (parity[sum % 11] == code.toUpperCase()) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    // 输入框值变化
    inputChange(value) {
      this.value = value
    },
  },

  mounted() { }
}
</script>
<style lang="less" scoped></style>
